export default __webpack_public_path__ + "static/f_logo_RGB-Blue_1024-5b4225fa4fc0717dea707628bda9ced4.png";